var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomModal', {
    attrs: {
      "customClass": "generic-modals v--modal new-modal",
      "height": "auto",
      "name": "embroideryModal",
      "width": "92%",
      "clickToClose": false
    },
    on: {
      "beforeOpen": _vm.beforeOpenModal,
      "closed": _vm.closeModal
    }
  }, [_c('CustomContainer', {
    staticClass: "new-modal-wrapper customs-tools",
    attrs: {
      "elementType": "section"
    }
  }, [_c('ModalHeader', {
    attrs: {
      "backDisabled": _vm.disableButtons,
      "closeDisabled": _vm.disableButtons,
      "headerImg": true,
      "includeBack": _vm.isBackButtonVisible,
      "modalTitle": _vm.translations.embroideryModalTitle
    },
    on: {
      "backEvent": function backEvent($event) {
        _vm.$refs.content.goBackAction ? _vm.$refs.content.goBackAction() : _vm.$modal.hide('embroideryModal');
      },
      "closeEvent": _vm.closeAction
    }
  }), _c('CustomContainer', {
    staticClass: "new-modal-main-views-wrapper",
    attrs: {
      "elementType": "section"
    }
  }, [_c(_vm.componentName, {
    ref: "content",
    tag: "component",
    on: {
      "showBackButton": _vm.setBackButtonVisible,
      "blockCtaPrimaryButton": _vm.blockCtaPrimaryButton,
      "disableButtons": _vm.setDisableButtons
    }
  })], 1), _c('CustomContainer', {
    staticClass: "new-modal-button-nav"
  }, [_c('CustomContainer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isCtaSecondaryButtonVisible,
      expression: "isCtaSecondaryButtonVisible"
    }],
    staticClass: "new-modal-button-nav-container"
  }, [_c('CustomButton', {
    attrs: {
      "customClass": "new-modal-button-nav-container-cta expanded secondary",
      "keyTranslation": "personalizeRemove",
      "type": "button"
    },
    on: {
      "click": _vm.removePersonalization
    }
  })], 1), _c('CustomContainer', {
    staticClass: "new-modal-button-nav-container tooltip-container"
  }, [_c('CustomTooltip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isCtaPrimaryBlocked,
      expression: "isCtaPrimaryBlocked"
    }],
    attrs: {
      "customsClasses": "tooltip-embroidery-modal cta-action"
    }
  }, [_c('div', {
    staticClass: "embroidery-main-view-label-tooltip-error-icon"
  }, [_vm._v("!")]), _c('p', [_vm._v(_vm._s(this.translations["personalizeDesc4"])), _c('br'), _vm._v(_vm._s(this.translations["personalizeDesc5"]))])]), _c('CustomButton', {
    attrs: {
      "customClass": "new-modal-button-nav-container-cta expanded primary",
      "type": "button",
      "isDisabled": _vm.isCtaPrimaryBlocked || _vm.disableButtons,
      "keyTranslation": _vm.ctaButtons[_vm.componentName]
    },
    on: {
      "click": function click($event) {
        _vm.$refs.content.ctaAction ? _vm.$refs.content.ctaAction() : _vm.$modal.hide('embroideryModal');
      }
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }